import { type FC, type ReactNode } from "react";
import { FieldError } from "react-hook-form";
import { cn } from "../lib/utils";
import { Checkbox, CheckboxProps } from "./Checkbox";

export type CheckboxOptionProps = Omit<CheckboxProps, "ref"> & {
	label?: ReactNode;
	labelClassName?: string;
	error?: FieldError;
	readonly?: boolean;
	condensed?: true;
	tooltip?: ReactNode;
};

export const CheckboxOption: FC<CheckboxOptionProps> = ({
	label,
	labelClassName,
	tooltip,
	condensed,
	...rest
}) => (
	<div
		className={cn(
			"group flex items-center h-[29px] space-x-[14px] cursor-pointer",
			rest.readonly ? "cursor-default" : "cursor-pointer",
			condensed ? "space-x-[11px]" : undefined,
		)}
		onClick={(e) => {
			if (rest.readonly) {
				e.preventDefault();
				e.stopPropagation();
				return;
			}
			rest.onChange && rest.onChange(!rest.checked);
		}}
	>
		<Checkbox {...rest} condensed={condensed} />
		{label !== undefined && (
			<span
				className={cn(
					"text-[15px] font-normal text-primary leading-[19px]",
					condensed ? "text-[13px]" : undefined,
					labelClassName,
				)}
			>
				{label} {tooltip}
			</span>
		)}
	</div>
);
